import React from "react";
import styles from "./ActionBtnCss.module.css"

class ActionBtn extends React.Component {
    render() {
        const {position, handleClick, iconName, title} = this.props;
        const iconClass = iconName === "message" ? styles.message : styles.plus;
        return (
            <button title={title}
                    style={position}
                    className={`${styles.action_btn} ${iconClass}`} onClick={handleClick}/>
        )
    }
}

export default ActionBtn;